import { DisplayConfigType } from 'formats/display/lib/config';
import { observer } from 'mobx-react';
import { CreativeBuilder } from './creative';
import { OptoutIconBuilder } from './opt-out-icon';
import { TagInjectorBuilder } from './tag-injector';
import { ComponentBuilder } from './types';
import { CtaBuilder } from './cta';
import { ExpandButtonBuilder } from './expand-button';
import { CloseButtonBuilder } from './close-button';
import { ArrowButtonBuilder } from './arrow-btn';
import { BrandBarBuilder } from './brand-bar';
import { BorderLayerBuilder } from './border-layer';

type Component = { component: () => JSX.Element; key: string };

export class ComponentsBuilder {
  static builders: {
    key: string;
    builder: ComponentBuilder<DisplayConfigType>;
  }[] = [
    { key: 'optout-icon', builder: new OptoutIconBuilder() },
    { key: 'creative', builder: new CreativeBuilder() },
    { key: 'tag-injector', builder: new TagInjectorBuilder() },

    { key: 'cta', builder: new CtaBuilder() },
    { key: 'expand-btn', builder: new ExpandButtonBuilder() },
    { key: 'close-btn', builder: new CloseButtonBuilder() },
    { key: 'arrow-btn', builder: new ArrowButtonBuilder() },
    { key: 'brand-bar', builder: new BrandBarBuilder() },
    { key: 'border-layer', builder: new BorderLayerBuilder() }
  ];

  static build(adContext: AdContext, config: DisplayConfigType): Component[] {
    const result: Component[] = [];

    ComponentsBuilder.builders
      .filter(b => b.builder.isInjectable(adContext, config))
      .forEach(b => {
        const component = b.builder.build(adContext, config);
        result.push({
          component: observer(component),
          key: b.key
        });
      });

    if (!result.length) {
      throw new Error('No Child Component Injected');
    }

    return result;
  }
}
